<template>
	<div>
		<ListHeaderComponent :background="background">
			<span slot="title">{{title}}</span>
		</ListHeaderComponent>
		<EventHeaderComponent></EventHeaderComponent>
		<DetailsComponent></DetailsComponent>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	import ListHeaderComponent from '@/components/ListHeaderComponent'
	import EventHeaderComponent from '@/components/Event/EventHeaderComponent'
	import DetailsComponent from '@/components/Event/DetailsComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'

	export default {
		components: {
			ListHeaderComponent,
			EventHeaderComponent,
			DetailsComponent,
			ContactComponent,
			PartnersComponent
		},
		data () {
			return {
				title: this.$t('events.header'),
				background: 'events'
			}
		},
		methods: {
			scrollTop () {
				this.$scrollTo('body', 1, {})
			},
			scrollToJudges () {
				window.setTimeout(() => {
					const section = document.querySelector('#judges')
					const sectionHeight = section.offsetTop
					const heightToScroll = sectionHeight - window.pageYOffset

					window.scrollBy({
						top: heightToScroll,
						behavior: 'smooth'
					})
				}, 350)
			}
		},
		mounted () {
			if (this.$route.query.judges === 'all') {
				this.scrollToJudges()
			} else {
				this.scrollTop()
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Event.vue